// export const baseURL = process.env.REACT_APP_BASE_URL;
// export const secretKey = process.env.REACT_APP_SECRET_KEY;
// export const projectName = process.env.REACT_APP_PROJECT_NAME;
// export const bucketName = process.env.REACT_APP_BUCKET_NAME;
// export const hostname = process.env.REACT_APP_HOST_NAME;
// export const aws_access_key_id = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
// export const aws_secret_access_key = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;

export const baseURL = "https://api.vps1.followapp.co.in/";
export const secretKey =
  "7ff3f938af9de61aa83c625f702cc357f7dad32246d1757c37eb153606587a55";
export const projectName = "Follow App";
export const bucketName = "follow-app-bucket";
export const hostname = "us-east-1";
export const aws_access_key_id = "AKIA54WIF6QI5RZCQGUD";
export const aws_secret_access_key = "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";
